<template>
  <div>
    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

    <div class="box">
      <admin-box-item title="파트너 설정">
        <div class="column is-full">
          <admin-form-item label="파트너명" desc="서비스에서 표시될 '파트너' 명칭을 수정할 수 있습니다.">
            <input type="text" class="input-border" v-model="partnerName" @keyup="e => partnerName = e.target.value">
          </admin-form-item>
        </div>
        <div class="column is-full" style="margin-top:20px">
          <admin-form-item label="파트너 등록 방식" desc="파트너센터 가입 버튼에서 진행할 파트너 등록 방식을 선택합니다.">
            <lp-radio :val.sync="signupType"
                      label_name="label"
                      value_name="value"
                      :data="signupOptions"></lp-radio>
          </admin-form-item>
        </div>
      </admin-box-item>
    </div>

  </div>
</template>

<script>

  import LpRadio from "../../module/common/LpRadio";
  export default {
    layout: 'Main',
    components: {
      LpRadio
    },
    watch:{

    },
    created() {
      this.getData();
    },
    data() {
      return {
        partnerName: '파트너',
        signupType: 0,
        signupOptions: [
          {
            label: '바로 등록',
            value: 0
          },
          {
            label: '파트너 등록 승인요청',
            value: 1
          },
          {
            label: '업체 등록 문의',
            value: 2
          },
        ]
      }
    },
    methods: {
      getData() {
        this.$axios.get('admin/partner/setting').then(res => {
          if(res.status === 200) {
            this.signupType = res.data.signup_type;
            this.partnerName = res.data.partner_name;
          }
        });
      },
      save() {
        let param = {
          signup_type: this.signupType,
          partner_name: this.partnerName
        };
        this.$axios.post('admin/partner/setting', param).then(res => {
          if(res.status === 200) {
            this.toast('저장되었습니다.');
          }
        });
      }
    }
  }
</script>
